"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var mobx_react_1 = require("mobx-react");
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
var getInnerColor = function (style, colors) {
    if ((0, BlockStyleTypes_1.isSplashStyle)(style) && style.backgroundCard && style.backgroundCard.color) {
        return (0, GetBlockStyle_1.GetColor)(colors)(style.backgroundCard.color);
    }
    else {
        return (0, GetBlockStyle_1.GetColor)(colors)(style.background);
    }
};
var getOuterColor = function (style, colors) {
    return (0, GetBlockStyle_1.GetColor)(colors)(style.background);
};
var getH1Color = function (style, colors) {
    if (style.h1 != undefined) {
        return (0, GetBlockStyle_1.GetColor)(colors)(style.h1.color);
    }
    else {
        return "";
    }
};
var getTextColor = function (style, colors) {
    if (style.p != undefined) {
        return (0, GetBlockStyle_1.GetColor)(colors)(style.p.color);
    }
    else {
        return "";
    }
};
var StyleTile = (0, mobx_react_1.observer)(function (props) {
    var size = props.size, style = props.style, colors = props.colors;
    return (react_1.default.createElement("div", { className: "style-tile-v2 style-tile-v2--".concat(size, " center"), style: {
            backgroundColor: getOuterColor(style, colors),
        } },
        react_1.default.createElement("div", { className: "style-tile-v2__inner style-tile-v2__inner--".concat(size, " center"), style: {
                backgroundColor: getInnerColor(style, colors),
            } },
            style.h1 && style.h1.color && (react_1.default.createElement("span", { className: "style-tile-v2__capital-a", style: {
                    color: getH1Color(style, colors),
                } }, "A")),
            style.p && style.p.color && (react_1.default.createElement("span", { className: "style-tile-v2__lowercase-a", style: {
                    color: getTextColor(style, colors),
                } }, "a")))));
});
exports.default = StyleTile;
